var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordProtectedGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69431 6.29256C7.49039 5.49874 9.45265 5.05909 11.4489 5V11.7655H5.00006C5.00005 11.7655 5.00004 11.7655 5.00003 11.7655V7.26787C4.99849 7.0627 5.0632 6.8615 5.18638 6.68847C5.30955 6.51545 5.48593 6.37797 5.69431 6.29256ZM5.01475 13.2655C5.19434 16.571 7.01751 19.4769 10.5047 20.678L11.3374 20.9644C11.3743 20.9771 11.4115 20.989 11.4489 21V13.2655H5.01475ZM12.9489 13.2655V21C12.9862 20.989 13.0234 20.9771 13.0603 20.9644L13.893 20.678C17.3802 19.4769 19.2034 16.571 19.383 13.2655H12.9489ZM19.3977 11.7655V7.26787C19.3992 7.0627 19.3345 6.8615 19.2114 6.68847C19.0882 6.51545 18.9118 6.37797 18.7034 6.29256C16.9073 5.49873 14.9451 5.05909 12.9489 5V11.7655H19.3977Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordProtectedGroup);
export default __webpack_public_path__ + "static/media/password-protected-group.6c388d50bb878a45f9b2f7c10d67de40.svg";
export { ForwardRef as ReactComponent };